<template>
    <div>
        <img id="sun" class="astra" :style="astraStyle" :src="astraSrc"/>
    </div>
</template>
<script>
/* eslint-disable no-console*/
// const self = this;

const sunSrc = require("../assets/forest-sun.svg");
const moonSrc = require("../assets/forest-moon.svg");

export default {
    data(){
        return{
            astraStyle:{
                position: "absolute",
                width: "3rem",
                left: "0vw",
                top: "3rem"
            },
            astraSrc: sunSrc,
        }
    },
    created(){
        this.moveAstra()
        const interval = setInterval(this.moveAstra, 60 * 60 * 1000);

        console.log(interval)
    },
    // deactivated(){
    //     clearInterval(interval)
    // },
    methods: {
        moveAstra: function(){
            var h = (new Date()).getHours()
            var percent = 0;
            if ((h > 6 && h < 19)){
                percent = (h - 6)*100/12;
                // this.astraSrc = require("../assets/forest-sun.svg")
            }else{
                this.astraSrc = moonSrc;
                percent = (h - 18)*100/12;
                // this.astraSrc = require("../assets/forest-moon.svg")
            }
            this.astraStyle.left =  percent + "vw"
            this.astraStyle.top = (percent < 50) ? (50 - percent) * 3 / 50 + "rem" : (percent - 50) * 3 / 50 + "rem"
        }
    }
    
}
</script>
<style scoped>
    .astra{
        transition: all 2s ease-in-out;
        /* z-index: -1; */
    }
</style>